import React from "react";

const RadialGauge = ({ value, min = 0, max = 100, label = "", width = 240, height = 150 }) => {
  const cx = width / 2;
  const cy = height;
  const r = Math.min(width / 2 - 10, height - 10);

  const clamp = (v) => Math.max(min, Math.min(max, v));
  const safeValue = clamp(value);

  const valueToAngle = (v) => {
    const t = (v - min) / (max - min || 1);
    return -180 + t * 180;
  };

  const polarToXY = (angleDeg, radius) => {
    const a = (Math.PI / 180) * angleDeg;
    return { x: cx + radius * Math.cos(a), y: cy + radius * Math.sin(a) };
  };

  const arcPath = () => {
    const start = polarToXY(-180, r);
    const end = polarToXY(0, r);
    return `M ${start.x} ${start.y} A ${r} ${r} 0 0 1 ${end.x} ${end.y}`;
  };

  const angle = valueToAngle(safeValue);
  const needleEnd = polarToXY(angle, r * 0.85);

  const mid = (min + max) / 2;
  const tick = (v, len = 10) => {
    const a = valueToAngle(v);
    const p1 = polarToXY(a, r);
    const p2 = polarToXY(a, r - len);
    return { p1, p2 };
  };

  const minTick = tick(min, 12);
  const midTick = tick(mid, 12);
  const maxTick = tick(max, 12);

  return (
    <div className="dg-gauge">
      <svg width={width} height={height + 18} viewBox={`0 0 ${width} ${height + 18}`}>
        <path d={arcPath()} className="dg-arc" />

        <line x1={minTick.p1.x} y1={minTick.p1.y} x2={minTick.p2.x} y2={minTick.p2.y} className="dg-tick" />
        <line x1={midTick.p1.x} y1={midTick.p1.y} x2={midTick.p2.x} y2={midTick.p2.y} className="dg-tick" />
        <line x1={maxTick.p1.x} y1={maxTick.p1.y} x2={maxTick.p2.x} y2={maxTick.p2.y} className="dg-tick" />

        <line x1={cx} y1={cy} x2={needleEnd.x} y2={needleEnd.y} className="dg-needle" />
        <circle cx={cx} cy={cy} r="6" className="dg-cap" />

        <text x={cx} y={height + 14} className="dg-value" textAnchor="middle">
          {label}
        </text>
      </svg>
    </div>
  );
};

export default RadialGauge;